import { benefitSummarySection } from './benefit-summary-section'
import { policyValueTableSection, iSmartPolicyValueTableSection } from './policy-value-table-section'
import { policyValueTableExampleSection } from './policy-value-table-example-section'
import { investmentBenefitTableSection } from './investment-benefit-table-section'
import { investmentBenefitTableGlobalIndexSection } from './investment-benefit-table-global-index-16-6-section'
import { basicPlanConditionSection } from './basicplan-condition-section'
import { basicPlanConditionGIOSection } from './basicplan-condition-gio-section'
import { basicPlanConditionISmartSection } from './basicplan-condition-ismart-section'
import { profileSnapshotSection } from './profile-snapshot-section'
import { productBenefitsSection } from './product-benefit-section'

export const section = {
  policyValueTable: policyValueTableSection,
  policyValueTableExample: policyValueTableExampleSection,
  benefitSummary: benefitSummarySection,
  investmentBenefitTable: investmentBenefitTableSection,
  investmentBenefitTableGlobalIndex: investmentBenefitTableGlobalIndexSection,
  basicPlanCondition: basicPlanConditionSection,
  basicPlanConditionGIO: basicPlanConditionGIOSection,
  basicPlanConditionISmart: basicPlanConditionISmartSection,
  profileSnapshot: profileSnapshotSection,
  basicPlanBenefit: productBenefitsSection,
  iSmartPolicyValueTable: iSmartPolicyValueTableSection,
}
